import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types/entertainment";

interface NewsCardProps {
  article: NewsArticle;
  variant?: "card" | "list";
}

export default function NewsCard({ article, variant = "card" }: NewsCardProps) {
  if (variant === "list") {
    return (
      <Link
        to={`/news/${article.id}`}
        className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 sm:flex-row sm:gap-4"
      >
        <div className="h-40 w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-24 sm:w-40">
          <img
            src={article.cover}
            alt={`${article.title} 配图`}
            title={`${article.title} - 影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <div className="flex min-w-0 flex-1 flex-col">
          <div className="flex flex-wrap items-center gap-2">
            <span className="rounded bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
              {article.category}
            </span>
            <span className="text-xs text-foreground-500">{article.date}</span>
          </div>
          <h3 className="mt-2 line-clamp-2 text-sm font-semibold text-foreground-950 group-hover:text-primary-600 md:text-base">
            {article.title}
          </h3>
          <p className="mt-1.5 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-sm">
            {article.summary}
          </p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-200 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="aspect-[16/10] w-full overflow-hidden bg-background-200">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
      </div>
      <div className="flex flex-1 flex-col p-4">
        <div className="flex items-center gap-2">
          <span className="rounded bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-900">
            {article.category}
          </span>
          <span className="text-xs text-foreground-500">{article.date}</span>
        </div>
        <h3 className="mt-2.5 line-clamp-2 text-base font-semibold text-foreground-950 group-hover:text-primary-600">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">
          {article.summary}
        </p>
      </div>
    </Link>
  );
}